// @ts-nocheck
// Widget Modified for RSL
import { emptyGuid } from "@insite/client-framework/Common/StringHelpers";
// import StyledWrapper from "@insite/client-framework/Common/StyledWrapper"; // Starter Custom Code
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import {
    getCategoriesDataView,
    getCategoryState,
    getSubCategoryIds,
} from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import loadCategories from "@insite/client-framework/Store/Data/Categories/Handlers/LoadCategories";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
// import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer"; // Store Custom Code
import GridItem, { GridItemProps, GridWidths } from "@insite/mobius/GridItem";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
// import Typography, { TypographyProps } from "@insite/mobius/Typography"; // Starter Custom Code
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css, ThemeProps, withTheme } from "styled-components";

/* Starter Custom Code - Start */
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import getTextAlignmentField, { textAlignmentOptions } from "@store/Framework/Common/Fields/Toolkit/textAlignment";
import DataViewLoadingOverlay from "@store/Library/Components/Toolkit/DataViewLoadingOverlay";
import { LoadingOverlayProps } from "@store/MobiusOverrides/LoadingOverlay/LoadingOverlay";
import { categoryListProps } from "@store/Themes/common/props/category";
import { typographyGetNoResultsAltProps, typographyGetNoResultsProps } from "@store/Themes/common/props/typography";
import cssProp from "@toolkit/Framework/Common/Utilities/cssProp";
import {
    DataOption,
    DataOptions,
    getDataOptionsFieldDefinition,
} from "@toolkit/Framework/Common/Utilities/dataOptions";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { LiteralUnion } from "@toolkit/Framework/Types/Common";
import { gridGapStyles, overrideSpacingStyles } from "@toolkit/Themes/common/mixins";
import sortBy from "lodash/sortBy";

/* Store Custom Code - Start */
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import { safeColor } from "@insite/mobius/utilities";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import { borderedTitle } from "@store/Themes/common/mixins/title";
import { blueUppercaseTitleStyles } from "@store/Themes/common/mixins/typography";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
/* Store Custom Code - End */

const StyledSpan = getStyledWrapper("span");

export type CategoryListVariantOption = DataOption;
export interface CategoryListVariantOptionMapper {
    standard: CategoryListVariantOption;
    compact: CategoryListVariantOption;
}
export type CategoryListVariantOptions = DataOptions<CategoryListVariantOption> & CategoryListVariantOptionMapper;
export type CategoryListVariant = LiteralUnion<keyof CategoryListVariantOptionMapper>;

export const categoryListVariantOptions: CategoryListVariantOptions = {
    standard: { id: "standard", displayName: "Standard", isDefault: true },
    compact: { id: "compact", displayName: "Compact" },
};
/* Starter Custom Code - End */

const enum fields {
    showImages = "showImages",
    showOnlyTopLevelCategories = "showOnlyTopLevelCategories",
    // Starter Custom Code
    selectedCategoryIds = "selectedCategoryIds",
    showSubCategories = "showSubCategories",
    subCategoriesToShow = "subCategoriesToShow",
    title = "title",
    titleAlignment = "titleAlignment",
    variant = "variant",
    // Store Custom Code
    mobileOneColumn = "mobileOneColumn",
}

/* Starter Custom Code - Start */
const titleAlignmentField = getTextAlignmentField(fields.titleAlignment);
/* Starter Custom Code - End */

interface OwnProps extends WidgetProps {
    fields: {
        [fields.showImages]: boolean;
        [fields.showOnlyTopLevelCategories]: boolean;
        // Starter Custom Code
        [fields.selectedCategoryIds]: string[];
        [fields.showSubCategories]: boolean;
        [fields.subCategoriesToShow]: number;
        [fields.title]: string;
        [fields.titleAlignment]: string;
        [fields.variant]: string;
        // Store Custom Code
        [fields.mobileOneColumn]: string;
    };
}

const mapStateToProps = (state: ApplicationState, props: OwnProps) => {
    const getCategoriesParameter = {
        maxDepth: props.fields.showOnlyTopLevelCategories ? 1 : 2, // Store Custom Code
        includeStartCategory: false,
    };
    return {
        categoriesDataView: getCategoriesDataView(state, getCategoriesParameter),
        getCategoriesParameter,
        topLevelCategoryIds: getSubCategoryIds(state, emptyGuid) || [], // Starter Custom Code
        // Starter Custom Code
        defaultImagePath: getSettingsCollection(state).extensionCatalogSettings?.notFoundCategorySmallImagePath,
    };
};

const mapDispatchToProps = {
    loadCategories,
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    ThemeProps<BaseTheme>;

export interface CategoryListStyles {
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    container?: GridContainerProps;
    categoryItem?: GridItemProps;
    innerContainer?: GridContainerProps;
    categoryImageItem?: GridItemProps;
    categoryImageLink?: LinkPresentationProps;
    categoryImage?: LazyImageProps;
    categoryNameLinkItem?: GridItemProps;
    categoryNameLink?: LinkPresentationProps;
    categoryName?: TypographyProps;
    subCategoryNameLinkItem?: GridItemProps;
    subCategoryNameLink?: LinkPresentationProps;
    viewMoreLinkItem?: GridItemProps;
    viewMoreLink?: LinkPresentationProps;
    // Starter Custom Code
    wrapper?: InjectableCss;
    title?: TypographyProps;
    noResultsContainer?: InjectableCss;
    noResultsText?: TypographyPresentationProps;
    loadingOverlay?: LoadingOverlayProps;
    categoryLink?: LinkPresentationProps;
    categoryImageWrapper?: InjectableCss;
    subCategoryList?: TypographyProps;
    subCategoryListItem?: TypographyProps;
    // Store Custom Code
    backgroundOverlay?: InjectableCss;
}

export const categoryListStyles: CategoryListStyles = {
    /* Store Custom Code - Start */
    title: {
        variant: "h2",
        css: css`
            ${blueUppercaseTitleStyles()}
        `,
    },
    /* Store Custom Code - End */
    noResultsText: typographyGetNoResultsAltProps(),
    loadingOverlay: categoryListProps.loadingOverlay,
    /* Store Custom Code - Start */
    container: {
        gap: 20,
    },
    categoryItem: {
        as: "li",
        width: [6, 6, 4, 4, 4],
    },
    /* Store Custom Code - End */
    categoryLink: categoryListProps.itemLink,
    categoryImageWrapper: categoryListProps.itemImageWrapper,
    /* Store Custom Code - Start */
    categoryImage: {
        width: "160px",
        height: "160px",
    },
    categoryName: {
        color: "primary.contrast",
        size: pxToRem(20),
        weight: 600,
        css: css`
            ${borderedTitle(null, null, 70)}
            padding-bottom: 0;
            margin: 0 ${pxToRem(6)};
            text-align: center;
            line-height: 1.25;

            &::after {
                content: "";
                position: absolute;
                bottom: -${pxToRem(6)};
                left: 50%;
                transform: translateX(-50%);
                transition: ${transitionHoverStyles("width", "max-width")};
            }
        `,
    },
    /* Store Custom Code - End */
    subCategoryList: categoryListProps.itemList,
    subCategoryListItem: categoryListProps.itemListItem,
    subCategoryNameLink: categoryListProps.itemListLink,
    viewMoreLink: categoryListProps.itemListMoreLink,
    /* Store Custom Code - Start */
    categoryImageLink: {
        css: css`
            width: 100%;
            ${breakpointValues([pxToRem(90), pxToRem(100), null, null, null], ["height"])}
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;

            > span {
                width: 100%;
                height: 100%;
            }

            &:hover,
            &:focus {
                .background-overlay {
                    background-color: ${safeColor("#000000").rgb().alpha(0.65).string()};
                }

                .bordered-text::after {
                    width: 100%;
                    max-width: 100%;
                }
            }
        `,
    },
    backgroundOverlay: {
        css: css`
            width: 100%;
            height: 100%;
            background-color: ${safeColor("#000000").rgb().alpha(0.5).string()};
            display: flex;
            justify-content: center;
            align-items: center;
            transition: ${transitionHoverStyles("background-color")};
        `,
    },
    /* Store Custom Code - End */
};

/* Starter Custom Code - Start */
export const categoryListCompactStyles: CategoryListStyles = {
    title: categoryListProps.title,
    noResultsText: typographyGetNoResultsProps(),
    container: {
        gap: 0,
        offsetProps: {
            as: "ul",
        },
        css: gridGapStyles(pxToRemArray([20, null, 30])),
    },
    categoryItem: {
        as: "li",
        width: [6, 4, 3, 2.4 as any, 2],
    },
    categoryLink: mergeProps<CategoryListStyles["categoryLink"]>(categoryListProps.itemLink, {
        css: css`
            padding: ${pxToRem(15)};
            border: 1px solid ${getColor("common.border")};
            border-radius: ${x => x.theme.design.common.contentRadius};
        `,
    }),
    categoryImageWrapper: categoryListProps.itemImageWrapper,
    categoryImage: categoryListProps.itemImage,
    categoryName: mergeProps<CategoryListStyles["categoryName"]>(categoryListProps.itemTitle, {
        forwardAs: "h3",
        css: css`
            ${overrideSpacingStyles(pxToRem(15), null)}
            padding: 0;
        `,
    }),
};
/* Starter Custom Code - End */

// Starter Removed - styles

class CategoryList extends React.Component<Props> {
    container = React.createRef<HTMLDivElement>();
    // Starter Removed - categoryItemStyles

    UNSAFE_componentWillMount(): void {
        const { categoriesDataView, getCategoriesParameter, loadCategories } = this.props;
        if (!categoriesDataView.isLoading && !categoriesDataView.value) {
            loadCategories(getCategoriesParameter);
        }
    }

    // Starter Removed - recalculateWidth

    componentDidMount() {
        // Starter Removed - recalculateWidth
        // Starter Removed - addEventListener
    }

    componentWillUnmount() {
        // Starter Removed - removeEventListener
    }

    componentDidUpdate(prevProps: Props) {
        // Starter Removed - recalculateWidth
    }

    render() {
        const {
            categoriesDataView,
            topLevelCategoryIds,
            fields: {
                showImages,
                showOnlyTopLevelCategories = true, // Store Custom Code
                // Starter Custom Code
                selectedCategoryIds,
                showSubCategories: baseShowSubCategories = false, // Store Custom Code
                subCategoriesToShow: baseSubCategoriesToShow,
                title,
                titleAlignment,
                variant,
                // Store Custom Code
                mobileOneColumn,
            },
            // Starter Custom Code
            defaultImagePath,
        } = this.props;
        /* Starter Custom Code - Start */
        const isCompact = variant === categoryListVariantOptions.compact.id;
        const styles = isCompact ? categoryListCompactStyles : categoryListStyles;
        /* Starter Custom Code - End */

        if (categoriesDataView.isLoading) {
            // Starter Removed - return
        }

        if (!categoriesDataView.value || !topLevelCategoryIds) {
            // Starter Removed - return
        }

        /* Starter Custom Code - Start */
        const showSubCategories = baseShowSubCategories && !isCompact;
        const subCategoriesToShow = baseSubCategoriesToShow || 4;

        const titleCss = css`
            ${styles.title?.css}
            ${cssProp("text-align", titleAlignment)}
        `;

        const linkCss = css`
            ${styles.categoryLink?.css}
            ${showSubCategories && "height: auto;"}
        `;

        const noResultsTextCss = css`
            ${styles.noResultsText?.css}
            ${cssProp("text-align", titleAlignment)}
        `;

        /* Store Custom Code - Start */
        const containerCss = {
            ...styles.container,
            ...(mobileOneColumn ? { gap: 10 } : {}),
            css: css`
                ${styles.container?.css}
                ${GridOffset} {
                    justify-content: ${titleAlignment === "left"
                        ? "flex-start"
                        : titleAlignment === "right"
                        ? "flex-end"
                        : titleAlignment};
                }
            `,
        } as GridContainerProps;

        const categoryItemStyle = {
            ...styles.categoryItem,
            ...(mobileOneColumn ? { width: [12, 6, 4, 4, 4] } : {}),
            css: css`
                ${styles.categoryItem?.css}
            `,
        } as GridItemProps;
        /* Store Custom Code - End */

        let categories = categoriesDataView.value?.filter(o =>
            (showOnlyTopLevelCategories ? topLevelCategoryIds : selectedCategoryIds).includes(o.id),
        );

        if (!showOnlyTopLevelCategories) {
            categories = sortBy(categories, ["shortDescription"]);
        }

        return (
            <StyledWrapper ref={this.container} {...styles.wrapper}>
                {Boolean(title) && (
                    <Typography {...styles.title} css={titleCss}>
                        {title}
                    </Typography>
                )}
                <DataViewLoadingOverlay dataView={categoriesDataView} {...styles.loadingOverlay}>
                    {!categoriesDataView.value?.length ? (
                        <StyledWrapper {...styles.noResultsContainer}>
                            <Typography {...styles.noResultsText} css={noResultsTextCss}>
                                {siteMessage("Categories_Not_Found")}
                            </Typography>
                        </StyledWrapper>
                    ) : (
                        <GridContainer {...containerCss /* Store Custom Code */}>
                            {categories?.map(category => {
                                /* Store Custom Code - Start */
                                const categoryImageStyles = {
                                    css: css`
                                        ${styles.categoryImageLink?.css || ""}
                                        background-image: url(${category.smallImagePath || defaultImagePath});
                                        ${mobileOneColumn
                                            ? breakpointValues(
                                                  [pxToRem(56), pxToRem(100), null, null, null],
                                                  ["height"],
                                              )
                                            : null}
                                    `,
                                };
                                return (
                                    <GridItem key={category.id.toString()} {...categoryItemStyle}>
                                        <Link href={category.path} {...categoryImageStyles}>
                                            <StyledWrapper {...styles.backgroundOverlay} className="background-overlay">
                                                <Typography {...styles.categoryName} className="bordered-text">
                                                    {category.shortDescription}
                                                </Typography>
                                            </StyledWrapper>
                                        </Link>
                                        {/* Store Custom Code - Removed subCategories */}
                                    </GridItem>
                                );
                                /* Store Custom Code - End */
                            })}
                        </GridContainer>
                    )}
                </DataViewLoadingOverlay>
            </StyledWrapper>
        );
        /* Starter Custom Code - End */
    }
}

const SubCategoryLinkView = ({
    category,
    // Starter Custom Code
    styles,
}: ReturnType<typeof linkMapStateToProps>) => {
    if (!category) {
        return null;
    }

    return (
        <Link href={category.path} {...styles.subCategoryNameLink}>
            {category.shortDescription}
        </Link>
    );
};

const linkMapStateToProps = (
    state: ApplicationState,
    ownProps: {
        categoryId: string;
        // Starter Custom Code
        styles: CategoryListStyles;
    },
) => ({
    category: getCategoryState(state, ownProps.categoryId).value,
    // Starter Custom Code
    styles: ownProps.styles,
});

const SubCategoryLink = connect(linkMapStateToProps)(SubCategoryLinkView);

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withTheme(CategoryList)),
    definition: {
        group: "Categories",
        icon: "list-ul",
        // Starter Removed - allowedContexts
        fieldDefinitions: [
            /* Starter Custom Code - Start */
            {
                name: fields.title,
                displayName: "Title",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Contextual",
            },
            {
                ...titleAlignmentField.definition,
                displayName: "Title Alignment",
                defaultValue: textAlignmentOptions.center.id,
                fieldType: "Contextual",
                isVisible: x => Boolean(x.fields.title),
            },
            // Store Custom Code - Removed categoryListVariantOptions
            /* Starter Custom Code - End */
            // Store Custom Code - Removed showImages
            // Store Custom Code - Removed showOnlyTopLevelCategories
            // Store Custom Code - Removed selectedCategoryIds
            // Store Custom Code - Removed showSubCategories
            // Store Custom Code - Removed subCategoriesToShow
            // Store Custom Code
            {
                name: fields.mobileOneColumn,
                displayName: "Use One column for mobile",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
            },
        ],
    },
};

export default widgetModule;
